export const MUSIC = [
  {
    src: 'https://cplayer.js.org/271db93022e3f8a079b4f3f727f2e3e9.mp3',
    poster: 'https://cplayer.js.org/1a0498ff9195b6540e102c03886b02f4.jpg',
    name: 'In my room',
    artist: 'FELT'
  },
  {
    name: '光るなら',
    artist: 'Goose house',
    src: 'https://cn-south-17-aplayer-46154810.oss.dogecdn.com/hikarunara.mp3',
    poster:
      'https://cn-south-17-aplayer-46154810.oss.dogecdn.com/hikarunara.jpg',
    lyric: 'https://cn-south-17-aplayer-46154810.oss.dogecdn.com/hikarunara.lrc'
  },
  {
    name: 'トリカゴ',
    artist: 'XX:me',
    src: 'https://cn-south-17-aplayer-46154810.oss.dogecdn.com/darling.mp3',
    poster: 'https://cn-south-17-aplayer-46154810.oss.dogecdn.com/darling.jpg',
    lrc: 'https://cn-south-17-aplayer-46154810.oss.dogecdn.com/darling.lrc'
  },
  {
    name: '前前前世',
    artist: 'RADWIMPS',
    src: 'https://cn-south-17-aplayer-46154810.oss.dogecdn.com/yourname.mp3',
    poster: 'https://cn-south-17-aplayer-46154810.oss.dogecdn.com/yourname.jpg',
    lrc: 'https://cn-south-17-aplayer-46154810.oss.dogecdn.com/yourname.lrc'
  }
]



// WEBPACK FOOTER //
// ./src/helper/const-music.js